import { compose } from "redux";
import { IAction } from "../../models/Action";
import { LOADER_IDENTIFIER } from "../../pages/AbilitationManagement/module/constants";
import { immutableSet } from "../../utils/immutable";
import { actionTypes } from "./tcActions";
import {
  STATE_IDENTIFIER,
} from "./tcConstants";
import emptyState from "./tcEmptyState";

const { TABLES_CONFIGURATION } = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.LOAD_TABLE_CONFIGURATION]: (state: any, action: any) =>
    compose(immutableSet([LOADER_IDENTIFIER], true))(state),
  [actionTypes.LOAD_TABLE_CONFIGURATION_SUCCESS]: (state: any, action: any) => {
    let tablesConfiguration = action.payload;

    return compose(
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([TABLES_CONFIGURATION], tablesConfiguration)
    )(state);
  },
  [actionTypes.LOAD_TABLE_CONFIGURATION_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([TABLES_CONFIGURATION], [])
    )(state),
};

// Reducer
export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.location.pathname === "/login"
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
